import { useMemo } from "react";

import type * as Repository from "../../../_repository";
import type * as Type from "../type";

type Props = {
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};
type Result = {
	viewData: Type.ViewData;
};

export const useViewDataConverter = ({
	optionPmsColorListQueryData: {
		optionPmsColorList: { optionColors },
	},
}: Props): Result => {
	return useMemo((): Result => {
		return {
			viewData: {
				optionPmsColorList: optionColors.map(({ optionID, optionName, color }) => ({
					id: optionID,
					nameText: optionName,
					color,
				})),
			},
		} satisfies Result;
	}, [optionColors]);
};
